// import React from "react";
import { setTitle } from "../../helpers/MetaTag";
import HomeBanner from "../../components/sections/front/sections/HomeBanner";
import HomeHowItWorks from "../../components/sections/front/sections/HomeHowItWorks";
// import Pricing from "../../components/sections/front/sections/Pricing";
// import ChoosePlan from "./account/ChoosePlan";
// import HomeFaq from "../../components/sections/front/sections/HomeFaq";

const Home = () => {
  setTitle("Memory Doddle | Home");

  return (
    <>
      <HomeBanner />
      <HomeHowItWorks />
      {/* <ChoosePlan fromHomePage /> */}
    </>
  );
};

export default Home;
